class AccessCardsSystemsAndBranchesDatatable {
    constructor(form, modal, accessCardID = null, numberOfSystems = 0, numberOfBranches = 0, numberOfBranchSegments = 0, numberOfSystemGroups = 0){
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.accessCardID = accessCardID;
        this.form = form;
        this.modal = modal;
        this.jQueryForm = $(form);
        this.addSystemsModal = accessCardID ?
            document.getElementById('add_systems_to_edit_access_card_modal') :
            document.getElementById('add_systems_to_create_access_card_modal');

        this.datatableElement = this.jQueryForm.find('#systems-and-branches-datatable');
        
        this.datatable = this.init(numberOfSystems, numberOfBranches, numberOfBranchSegments, numberOfSystemGroups);
        this.initActions();
    }
    init(numberOfSystems, numberOfBranches, numberOfBranchSegments, numberOfSystemGroups){
        const thisClass = this;
        let data = {
            organizationID: this.organizationID
        };
        if(this.accessCardID){
            data.accessCardID = this.accessCardID;
        }
        const datatable =  $(this.datatableElement).DataTable({
            searchDelay: 500,
            processing: false,
            serverSide: false,
            stateSave: false,
            sortable: false,
            info: false,
            ordering: false,
            paging: false,
            ajax: {
                url: '/access-cards/?do=getSystemsAccessCard',
                type: 'GET',
                data: data
            },
            select: {
                style: 'multi',
                selector: 'td:first-child input[type="checkbox"]',
                className: ''
            },
            language: {
                emptyTable: "No data found",
                loadingRecords: ""
            },
            drawCallback: function (settings) {
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(thisClass.form.querySelectorAll('#systems-and-branches-datatable_wrapper [data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                /** Remove header of table */
                thisClass.jQueryForm.find("#systems-and-branches-datatable_wrapper .dataTables_scrollHead, #systems-and-branches-datatable_wrapper thead").remove();

                /** Set rows to section (branches/systems) */
                const api = this.api();
                const rows = api.rows({
                    page: "current"
                }).nodes();
                let lastData = null;

                api.column(0, {
                    page: "current"
                }).data().each(function(uuid, i) {
                    let isBranch = !!api.rows(i).data().toArray()[0]['isBranch'];
                    let isBranchSegment = !!api.rows(i).data().toArray()[0]['isBranchSegment'];
                    let isSystemGroup = !!api.rows(i).data().toArray()[0]['isSystemGroup'];

                    let selectedNumber = numberOfSystems;
                    let className = 'systems';
                    let rowSectionName = 'Systems';
                    if(isBranch){
                        selectedNumber = numberOfBranches;
                        className = 'branches';
                        rowSectionName = 'Clouds & Branches';
                    } else if(isBranchSegment){
                        selectedNumber = numberOfBranchSegments;
                        rowSectionName = 'Branch Segments';
                        className = 'branch_segments'
                    } else if(isSystemGroup){
                        selectedNumber = numberOfSystemGroups;
                        rowSectionName = 'System Groups';
                        className = 'system_groups';
                    }
                    if(rowSectionName !== lastData){
                        lastData = rowSectionName;
                        $(rows).eq(i).before(
                            "<tr class=\"section fs-5 fw-bolder border-0"+(selectedNumber > 0 ? '' : ' d-none')+"\" data-section-name=\""+className+"\">" +
                            "   <td class=\"py-1 d-none\"></td>" +
                            "   <td class=\"py-1\">" + lastData +
                            "       <span class=\"badge badge-sm badge-light-primary align-middle ms-1\">" +
                            "           <span id=\"access_card_"+className+"_selected\">" + selectedNumber + "</span>" +
                            "       </span>" +
                            "   </td>" +
                            "   <td class=\"py-1 text-end\">" +
                            "       <span class=\"text-decoration-underline-ga text-danger danger fs-7 remove-all-"+className+"-from-access-card\">Remove All</span>" +
                            "   </td>" +
                            "</tr>"
                        );
                    }
                });
            },
            createdRow: function (row, data) {
                /** Add classes to row for easy count number of systems/branches */
                if (data.isSystem) {
                    $(row).addClass('is-system');
                } else if(data.isBranch) {
                    $(row).addClass('is-branch');
                } else if(data.isBranchSegment) {
                    $(row).addClass('is-branch-segment');
                } else if(data.isSystemGroup) {
                    $(row).addClass('is-system-group');
                }
                /** Hide system/branch that is not in access card */
                if (!data.checked) {
                    $(row).addClass('d-none not-in-access-card');
                }
            },
            columns: [
                {
                    data: 'uuid',
                    className: 'd-none',
                    sortable: false,
                    render: function (data, type, row) {
                        if (row['isSystem']) {
                            return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3 fv-row">' +
                                '    <input class="form-check-input cursor-pointer" type="checkbox" name="systems[]" value="' + row['uuid'] + '" ' + (row['checked'] ? 'checked' : '') + '/>' +
                                '</div>';
                        } else if(row['isBranch']) {
                            return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3 fv-row">' +
                                '    <input class="form-check-input cursor-pointer" type="checkbox" name="branches[]" value="' + row['uuid'] + '" ' + (row['checked'] ? 'checked' : '') + '/>' +
                                '</div>';
                        } else if(row['isBranchSegment']) {
                            return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3 fv-row">' +
                                '    <input class="form-check-input cursor-pointer" type="checkbox" name="branchSegments[]" value="' + row['uuid'] + '" ' + (row['checked'] ? 'checked' : '') + '/>' +
                                '</div>';
                        } else if(row['isSystemGroup']) {
                            return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3 fv-row">' +
                                '    <input class="form-check-input cursor-pointer" type="checkbox" name="systemGroups[]" value="' + row['uuid'] + '" ' + (row['checked'] ? 'checked' : '') + '/>' +
                                '</div>';
                        }
                    }
                },
                {
                    data: 'name',
                    title: 'System / Branch',
                    sortable: false,
                    className: 'min-w-120px',
                    render: function (data, type, row) {
                        if (row['isSystem']) {
                            let iconUrl = '/media/goodaccess/icons/system/' + row['iconID'] + '.svg';
                            return '<div class="d-flex align-items-center">' +
                                '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                                '           <div class="symbol-label bg-light-primary border border-2 border-white' + (!row['isValid'] || row['isIsolated'] ? ' filter-grayscale' : '') + '">' +
                                '               <img src="' + iconUrl + '" alt="icon" class="h-40px">' +
                                '           </div>' +
                                (row['isAdvanced'] ? '<span class="symbol-badge badge badge-circle bg-primary start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+row['numberOfServices']+' services</div>">'+row['numberOfServices']+'</span>' : '')+
                                (!row['isValid'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-9 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Invalid</div>">&#33;</span>' : '') +
                                (row['isIsolated'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Isolated</div>">&#10005;</span>' : '') +
                                '       </div>' +
                                '       <div class="d-flex justify-content-start flex-column">' +
                                '           <div>' + (row['edit'] ? '<div id="' + row['uuid'] + '">' : '') + '<span class="fw-bold' + (row['edit'] ? ' text-decoration-underline-ga primary edit-system' : '') + ' text-primary mb-1 fs-6" data-system-name="' + row['name'] + '">' + row['name'] + '</span>' +
                                (row['isIcmpProtocolEnabled'] ? '<span class="ms-2 fst-italic fs-9 badge badge-sm badge-warning py-1" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>ICMP protocol enabled</div>">ICMP</span>' : '')+
                                (row['url'] ? '' : '<i class="fa-solid fa-eye-slash ga-text-primary-700 ms-2" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>Not visible as a System Shortcut in GoodAccess Client Application.</div>"></i>') +(row['edit'] ? '</div>' : '') + '</div>' +
                                '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">'+(row['url'] ?? row['host'])+'</span>' +
                                '       </div>' +
                                '   </div>';
                        } else if(row['isBranch']) {
                            let iconUrl = '/media/goodaccess/icons/branch/'+row['icon_id']+'.svg';
                            return '<div class="d-flex align-items-center">' +
                                '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                                '           <div class="symbol-label bg-light-primary border border-2 border-white">' +
                                '               <img src="'+iconUrl+'" alt="icon" class="h-40px">' +
                                '           </div>' +
                                (!row['is_connected'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Not Connected</div>">&#10005;</span>' : '<span class="symbol-badge badge badge-circle bg-success start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Connected</div>">\t\n' + '&#10003;</span>') +
                                '       </div>' +
                                '       <div class="d-flex justify-content-start flex-column">' +
                                '           <div>'+ (row['edit'] ? '<div id="' + row['branchUuid'] + '">' : '') +'<span class="fw-bold'+ (row['edit'] ? ' text-decoration-underline-ga primary edit-branch' : '') +' text-primary mb-1 fs-6" data-branch-name="'+row['name']+'">'+row['name']+'</span>'+(row['edit'] ? '</div>' : '')+'</div>' +
                                '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">'+row['subnet']+'</span>' +
                                '       </div>' +
                                '   </div>';
                        } else if(row['isBranchSegment']) {
                            return '<div class="d-flex align-items-center">' +
                                '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                                '           <div class="symbol-label bg-light-primary border border-2 border-white">' +
                                '               <i class="fa-solid fa-diagram-predecessor fs-2"></i>' +
                                '           </div>' +
                                '       </div>' +
                                '       <div class="d-flex justify-content-start flex-column">' +
                                '           <div>'+ (row['edit'] ? '<div id="' + row['branchUuid'] + '">' : '') +'<span class="fw-bold'+ (row['edit'] ? ' text-decoration-underline-ga primary edit-branch' : '') +' text-primary mb-1 fs-6" data-branch-name="'+row['name']+'">'+row['name']+'</span> <span class="fst-italic fs-7 text-primary">(part of <b>'+row['branchName']+'</b>)</span>'+(row['edit'] ? '</div>' : '')+'</div>' +
                                '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">'+row['subnet_range']+'</span>' +
                                '       </div>' +
                                '   </div>';
                        } else if(row['isSystemGroup']) {
                            return new GroupInfoGenerator().generateSystemTableView(row['name'], row['edit'], row['uuid'], row['numberOfSystems']);
                        }
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    sortable: false,
                    className: 'text-end w-75px',
                    render: function (data, type, row) {
                        return '<span class="text-decoration-underline-ga text-danger danger fs-7 remove-system-from-access-card">Remove</span>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if (numberOfSystems + numberOfBranches + numberOfBranchSegments + numberOfSystemGroups === 0) {
                thisClass.jQueryForm.find('#systems-and-branches-datatable_wrapper').hide();
                thisClass.jQueryForm.find('#systems-and-branches-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
                thisClass.jQueryForm.find('div[data-step="systems-branches"] [data-kt-docs-table-filter="search-parent"]').addClass('d-none');
            } else {
                thisClass.jQueryForm.find('div[data-step="systems-branches"] [data-kt-docs-table-filter="search-parent"]').removeClass('d-none');
                thisClass.jQueryForm.find('#systems-and-branches-datatable_wrapper').show();
                thisClass.jQueryForm.find('#systems-and-branches-datatable_no-results').removeClass('d-flex flex-center flex-column').addClass('d-none');
            }
        });
        return datatable;
    }
    initActions(){
        const thisClass = this;
        /** Search */
        let timer;
        const input = this.form.querySelector('div[data-step="systems-branches"] input[data-kt-docs-table-filter=search]');
        //Add event to search input
        if(input){
            input.addEventListener('keyup', function (e) {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    thisClass.searchDatatable(this.value.toLowerCase());
                }, 300);
            });
        }
    }
    searchDatatable(value) {
        /** Search only visible (selected) systems */
        let data = this.datatable.rows().data().toArray();
        let branchesInAccessCard = 0;
        let systemsInAccessCard = 0;
        let branchSegmentsInAccessCard = 0;
        let systemGroupsInAccessCard = 0;
        for(let i in data){
            let node = $(this.datatable.row(i).node());
            if(!node.hasClass('not-in-access-card')){
                if(value === '' || this.includeValue(data[i].name, value) ||
                    (data[i].isSystem && (this.includeValue(data[i].url, value))) ||
                    (data[i].isBrach && (this.includeValue(data[i].subnet, value))) ||
                    (data[i].isBrachSubnet && (this.includeValue(data[i].subnet_range, value)))
                ){
                    node.removeClass('d-none');
                    if(node.hasClass('is-system')){
                        systemsInAccessCard++;
                    } else if(node.hasClass('is-branch')){
                        branchesInAccessCard++;
                    } else if(node.hasClass('is-branch-segment')){
                        branchSegmentsInAccessCard++;
                    } else if(node.hasClass('is-system-group')){
                        systemGroupsInAccessCard++;
                    }
                } else {
                    node.addClass('d-none');
                }
            }
        }

        if(branchesInAccessCard > 0){
            this.datatableElement.find('[data-section-name="branches"]').removeClass('d-none');
        } else {
            this.datatableElement.find('[data-section-name="branches"]').addClass('d-none');
        }
        if(systemsInAccessCard > 0){
            this.datatableElement.find('[data-section-name="systems"]').removeClass('d-none');
        } else {
            this.datatableElement.find('[data-section-name="systems"]').addClass('d-none');
        }
        if(branchSegmentsInAccessCard > 0){
            this.datatableElement.find('[data-section-name="branch_segments"]').removeClass('d-none');
        } else {
            this.datatableElement.find('[data-section-name="branch_segments"]').addClass('d-none');
        }
        if(systemGroupsInAccessCard > 0){
            this.datatableElement.find('[data-section-name="system_groups"]').removeClass('d-none');
        } else {
            this.datatableElement.find('[data-section-name="system_groups"]').addClass('d-none');
        }

        if((branchesInAccessCard + systemsInAccessCard + branchSegmentsInAccessCard + systemGroupsInAccessCard) === 0){
            this.jQueryForm.find('#systems-and-branches-datatable_no-search-results').removeClass('d-none');
        } else {
            this.jQueryForm.find('#systems-and-branches-datatable_no-search-results').addClass('d-none');
        }
    }
    includeValue(value, search) {
        if(value !== '' && value !== null){
            return value.toLowerCase().includes(search);
        }
        return false;
    }
}
window.AccessCardsSystemsAndBranchesDatatable = AccessCardsSystemsAndBranchesDatatable;